import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import DetailRow from '../../../../../../components/DetailRow'
import useAuthorization from '../../../../../../hooks/useAuthorization'
import { PERMISSION_MAPPINGS } from '../../../AddEditUserModal/utils'

/**
 * Read-only product permission levels of a system user, in the order Edit System User lists them.
 */
function PermissionDetails({ permissions = {}, permissionLevels, permissionEntities }) {
  const { isAuthorizedForDiscover } = useAuthorization()

  const rows = useMemo(() => {
    const entitiesByName = Object.fromEntries(permissionEntities.map((entity) => [entity.module_name, entity]))
    const levelsById = Object.fromEntries(permissionLevels.map((level) => [level.id, level]))

    return PERMISSION_MAPPINGS.filter((mapping) => isAuthorizedForDiscover || mapping.moduleName !== 'discover')
      .filter((mapping) => entitiesByName[mapping.moduleName])
      .map((mapping) => ({
        moduleName: mapping.moduleName,
        title: mapping.title,
        levelName: levelsById[permissions[entitiesByName[mapping.moduleName].id]]?.name,
      }))
  }, [permissions, permissionLevels, permissionEntities, isAuthorizedForDiscover])

  return rows.map(({ moduleName, title, levelName }) => (
    <DetailRow
      key={moduleName}
      size="sm"
      label={<FormattedMessage id={title} />}
      value={levelName ? <FormattedMessage id={`USERPERMISSION.${levelName}`} /> : ''}
    />
  ))
}

PermissionDetails.propTypes = {
  /** Permission level id by permission entity id */
  permissions: PropTypes.objectOf(PropTypes.number),
  permissionLevels: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })).isRequired,
  permissionEntities: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, module_name: PropTypes.string }))
    .isRequired,
}

export default React.memo(PermissionDetails)
